module.exports = __webpack_public_path__ + "static/media/chat-icon.b057d624.svg";